import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationStore = defineStore('notifications', () => {
  // State
  const notifications = ref([])

  // Actions
  const addNotification = (type, message, duration = 5000) => {
    const id = Date.now() + Math.random()

    const notification = {
      id,
      type, // success, error, warning, info
      message,
      timestamp: new Date()
    }

    notifications.value.push(notification)

    // Auto remove after duration
    if (duration > 0) {
      setTimeout(() => {
        removeNotification(id)
      }, duration)
    }

    return id
  }

  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index !== -1) {
      notifications.value.splice(index, 1)
    }
  }

  const clearNotifications = () => {
    notifications.value = []
  }

  // Convenience methods
  const success = (message, duration) => addNotification('success', message, duration)
  const error = (message, duration) => addNotification('error', message, duration)
  const warning = (message, duration) => addNotification('warning', message, duration)
  const info = (message, duration) => addNotification('info', message, duration)

  return {
    notifications,
    addNotification,
    removeNotification,
    clearNotifications,
    success,
    error,
    warning,
    info
  }
})